import { useApiPost } from '@/api/main/query'
import { FarmModel, NewFarmModel } from '@/entities/farm'
import { DialogFarmActions, Farms, farmsAPI } from '@/features/farm'
import {
  DialogAddRequisite,
  ReqFarmTabNames,
  REQUISITE_OPTIONS,
  requisiteAPI,
  RequisitesTable,
  NewRequisite,
  RequisiteModel,
  invalidateAllRequisiteData,
} from '@/features/requisites'
import { BaseButton, BaseTabs, MobileTabsSelect } from '@/shared/components'
import { useToast } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const Requisites = () => {
  const navigate = useNavigate()
  const [tabName, setTabName] = useState<ReqFarmTabNames>('requisites')
  const [modalAddRequisiteVisible, setModalAddRequisiteVisible] = useState(false)
  const [modalFarmActionsVisible, setModalFarmActionsVisible] = useState(false)
  const { addToast } = useToast()
  const queryClient = useQueryClient()

  const { mutate: createRequisit, isPending: isPandingCreateRequisit } = useApiPost<
    RequisiteModel,
    NewRequisite
  >(requisiteAPI.create, {
    onSuccess: (createdRequisite) => {
      addToast('Успех!', 'Реквизит создан', 'success')
      invalidateAllRequisiteData(queryClient)

      setModalAddRequisiteVisible(false)
      if (createdRequisite && createdRequisite.id) {
        navigate(`/requisites/${createdRequisite.id}`)
      }
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleAddRequisitSubmit = (data: NewRequisite) => {
    createRequisit(data)
  }

  const { mutate: createFarm, isPending: isPendingCreateFarm } = useApiPost<
    FarmModel,
    NewFarmModel
  >(farmsAPI.create, {
    onSuccess: () => {
      addToast('Успех!', 'Ферма создана', 'success')
      queryClient.invalidateQueries({ queryKey: ['farms'] })
      setModalFarmActionsVisible(false)
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleAddFarmSubmit = (data: any) => {
    createFarm(data)
  }

  const tabComponents = {
    requisites: <RequisitesTable />,
    farms: <Farms />,
  }

  return (
    <div className="flex flex-col gap-[30px] md:gap-6 w-full">
      <div className="flex md:justify-between items-center gap-2 w-full">
        <div className="hidden md:block">
          <BaseTabs
            tabs={REQUISITE_OPTIONS}
            selectedTab={tabName}
            onSelect={setTabName}
            direction="row"
            variant="secondary"
            className="text-3xl"
          />
        </div>
        <div className="md:hidden">
          <MobileTabsSelect
            tabs={REQUISITE_OPTIONS}
            selectedTab={tabName}
            onSelect={setTabName}
            className="text-3xl"
          />
        </div>
        <BaseButton
          variant="primary"
          padding="none"
          radius="md"
          className="md:px-[30px] w-full md:w-[250px] max-w-[250px]"
          iconPosition="left"
          icon={<Plus className="text-white" />}
          onClick={() =>
            tabName === 'requisites'
              ? setModalAddRequisiteVisible(true)
              : setModalFarmActionsVisible(true)
          }
        >
          <span className="hidden md:block">
            {tabName === 'requisites' ? 'Добавить реквизит' : 'Создать новую'}
          </span>
          <span className="md:hidden">{tabName === 'requisites' ? 'Добавить' : 'Создать'}</span>
        </BaseButton>
      </div>
      {tabComponents[tabName]}
      <DialogAddRequisite
        modalVisible={modalAddRequisiteVisible}
        setModalVisible={setModalAddRequisiteVisible}
        onSubmit={handleAddRequisitSubmit}
        isLoading={isPandingCreateRequisit}
      />
      <DialogFarmActions
        modalVisible={modalFarmActionsVisible}
        setModalVisible={setModalFarmActionsVisible}
        onSubmit={handleAddFarmSubmit}
        isLoading={isPendingCreateFarm}
      />
    </div>
  )
}
